import { SceneAnchorKey } from './scene/sceneRegistry';

/** Nav height in px — keep in sync with the h-16 nav and the sticky top-16 sections. */
export const LAB_NAV_HEIGHT = 64;

export interface ModelSectionConfig {
  key: Extract<SceneAnchorKey, 'asr' | 'tts' | 'slm'>;
  num: string;
  accent: string;
  align: 'left' | 'right';
}

/**
 * The three research models. Order defines both the page order and the scene
 * choreography beat order. Adding a section elsewhere on the page does not
 * affect these — the canvas re-measures anchors every frame.
 */
export const MODEL_SECTIONS: ModelSectionConfig[] = [
  { key: 'asr', num: '01', accent: '#8fd0ff', align: 'left' },
  { key: 'tts', num: '02', accent: '#ffc487', align: 'right' },
  { key: 'slm', num: '03', accent: '#cbaaff', align: 'left' },
];
